import "react-datepicker/dist/react-datepicker.css";
import { classNames, convertToDefEventPara } from "../../shared/utility";
import { Calendar } from "primereact/calendar";
import type { CalendarProps } from "primereact/calendar";
import type { ReactNode } from "react";

interface DatePickerInputProps extends Omit<CalendarProps, "value" | "onChange"> {
  classes?: string;
  label?: ReactNode;
  name: string;
  onChange: (event: { target: { name: string; value: Date | null } }) => void;
  value?: Date | string | null;
  labelOn?: boolean;
  error?: string;
  explanation?: ReactNode;
  labelDivClass?: string;
  labelClass?: string;
  parentClass?: string;
}

export default function DatePickerInput(props: DatePickerInputProps) {
  const {
    classes,
    label,
    name,
    onChange,
    value,
    labelOn,
    error,
    explanation,
    labelDivClass,
    labelClass,
    dateFormat,
    parentClass,
    ...other
  } = props;

  return (
    <div className={parentClass}>
      {labelOn ? (
        <div className="mb-1">
          <label
            htmlFor={name}
            className={classNames(
              labelClass ? labelClass : "text-sm",
              "block font-medium text-gray-900"
            )}
          >
            {label}
          </label>
        </div>
      ) : null}
      <div>
        <Calendar
          value={value ? new Date(value) : null}
          onChange={(e) => onChange(convertToDefEventPara(name, e.target.value ?? null))}
          dateFormat="M dd, yy"
          selectOtherMonths
          className="date-picker block w-full focus:outline-none sm:text-sm sm:max-w-xs md:max-w-full"
          {...other}
        />
        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
